export type Errors = Record<string, string>

export type ValidationResult = {
  isValid: boolean
  message?: string
}

export type Validator<T> = (obj: T) => ValidationResult

export type ValidatorRules<T> = {
  [key: string]: Validator<T> | Validator<T>[]
}

export type OverallValidationResult = {
  errors: Errors
  isValid: boolean
}

export const validator =
  <T>(rules: ValidatorRules<T>) =>
  (state: T): OverallValidationResult => {
    const keys = Object.keys(rules)
    const errors = {}

    for (const key of keys) {
      const validatorsForField = rules[key]
      let result: ValidationResult
      if (Array.isArray(validatorsForField)) {
        for (const val of validatorsForField) {
          result = val(state)
          if (!result.isValid) {
            break
          }
        }
      } else {
        result = validatorsForField?.(state)
      }

      if (!result?.isValid) {
        errors[key] = result.message
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    }
  }

export const revalidator =
  <T>(rules: ValidatorRules<T>) =>
  (state: T, errors: Errors, fieldName: string) => {
    const validatorsForField = rules[fieldName]
    let result: ValidationResult
    if (Array.isArray(validatorsForField)) {
      for (const val of validatorsForField) {
        result = val(state)
        if (!result.isValid) {
          break
        }
      }
    } else {
      result = validatorsForField?.(state)
    }

    if (result?.isValid) {
      delete errors[fieldName]
    }
  }
